import React, { useState } from 'react';
import { calculateAdvancedMetrics, formatTime } from '../utils/lapDetector';

const AdvancedMetrics = ({ lapDetails, allLapDetails }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const formatTimeUtil = typeof formatTime === 'function' ? formatTime : (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        } else {
            return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }
    };

    const metrics = calculateAdvancedMetrics(lapDetails, allLapDetails);

    const getTrendLabel = () => {
        if (metrics.trendAnalysis > 5) return '📈 Getting slower';
        if (metrics.trendAnalysis < -5) return '📉 Getting faster';
        return '→ Consistent';
    };

    if (!lapDetails || lapDetails.length === 0) {
        return null;
    }

    return (
        <div className="advanced-metrics-section">
            <button 
                onClick={() => setIsExpanded(!isExpanded)} 
                className="collapse-button" 
                style={{ width: '100%', textAlign: 'left', padding: '10px', marginBottom: '10px' }}
            >
                {isExpanded ? '▼' : '▶'} Advanced Metrics
            </button>
            {isExpanded && (
                <div className="advanced-metrics-grid">
                    {metrics.fastestLap && (
                        <div className="metric-box">
                            <div className="metric-label">Fastest Lap</div>
                            <div className="metric-value">{formatTimeUtil(metrics.fastestLap)}</div>
                        </div>
                    )}
                    {metrics.slowestLap && (
                        <div className="metric-box">
                            <div className="metric-label">Slowest Lap</div>
                            <div className="metric-value">{formatTimeUtil(metrics.slowestLap)}</div>
                        </div>
                    )}
                    {metrics.medianLapTime !== null && (
                        <div className="metric-box">
                            <div className="metric-label">Median Lap Time</div>
                            <div className="metric-value">{formatTimeUtil(metrics.medianLapTime)}</div>
                        </div>
                    )}
                    {metrics.stdDev !== null && (
                        <div className="metric-box">
                            <div className="metric-label">Consistency (Std Dev)</div>
                            <div className="metric-value">{metrics.stdDev.toFixed(1)}s</div>
                        </div>
                    )}
                    {metrics.best3LapAvg && (
                        <div className="metric-box">
                            <div className="metric-label">Best 3 Lap Avg</div>
                            <div className="metric-value">{formatTimeUtil(metrics.best3LapAvg)}</div>
                        </div>
                    )}
                    {metrics.best5LapAvg && (
                        <div className="metric-box">
                            <div className="metric-label">Best 5 Lap Avg</div>
                            <div className="metric-value">{formatTimeUtil(metrics.best5LapAvg)}</div>
                        </div>
                    )}
                    {metrics.trendAnalysis !== null && (
                        <div className="metric-box">
                            <div className="metric-label">Pace Trend</div>
                            <div className="metric-value metric-trend">{getTrendLabel()}</div>
                            <div className="metric-detail">{metrics.trendAnalysis > 0 ? '+' : ''}{metrics.trendAnalysis.toFixed(1)}%</div>
                        </div>
                    )}
                    {metrics.startTime && (
                        <div className="metric-box">
                            <div className="metric-label">Start Time</div>
                            <div className="metric-value metric-time">{metrics.startTime.toLocaleTimeString()}</div>
                        </div>
                    )}
                    {metrics.endTime && (
                        <div className="metric-box">
                            <div className="metric-label">End Time</div>
                            <div className="metric-value metric-time">{metrics.endTime.toLocaleTimeString()}</div>
                        </div>
                    )}
                    {metrics.totalActivityDuration && (
                        <div className="metric-box">
                            <div className="metric-label">Total Activity Time</div>
                            <div className="metric-value">{formatTimeUtil(metrics.totalActivityDuration)}</div>
                        </div>
                    )}
                    {metrics.outliersFiltered > 0 && (
                        <div className="metric-box">
                            <div className="metric-label">Outliers Filtered</div>
                            <div className="metric-value">{metrics.outliersFiltered}</div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AdvancedMetrics;
